import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import Axios from 'axios';
import { FEATURES } from "../../utils/constant";

const MyBillingPartyComponent = ({
  field: { name },
  form: { setFieldValue },
  orderModal,
  getBillingPartySelected,
  getConsigneeConsignorArray,
  billingPartyId,
  billingPartyBranchId,
  billingPartyBranchName,
  consignorName,
  consignorCode,
  consignorAddress,
  consignorGst,
  consigneeName,
  consigneeCode,
  consigneeAddress,
  consigneeGst,
  deliverToAddress,
  customerTypeName,
  customerTypeId,
  ...props
}) => {
  const [billingParty, setBillingParty] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [Txt, setTxt] = useState("");

  useEffect(() => {
    let token = localStorage.getItem('isloggedIn')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNumber')
    let billingPartyIds = localStorage.getItem('billingpartIds').toString()

    const urlInput = `/billing_party?customerNumber=${customerNo}&userId=${userId}`
    const urlOrderModalInput = `/billing_party?customerNumber=${customerNo}&userId=${userId}&billingPartyIds=${billingPartyIds}`

    Axios.get(`${process.env.REACT_APP_MASTER_API}${orderModal ? urlOrderModalInput : urlInput}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {
      setBillingParty(response.data.resultSet);
      getBillingPartySelected && getBillingPartySelected(billingPartyId, response.data.resultSet)


      setisloading(false)
    }))
      .catch(error => {
        console.log(error);
        setisloading(false)
      })

    // if(billingPartyId && billingPartyBranchId){
    //   getConsigneeConsignorArray && getConsigneeConsignorArray(billingPartyId, billingPartyBranchId)
    // }

  }, []);

  let handleSearch = (e, data) => {
    // if (data.searchQuery) {
    setisloading(true);
    let searchTerm = data.searchQuery;
    setTxt(data.searchQuery);
    setFieldValue(name, data.value);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party`,
    }).then((result) => {
      setBillingParty(result.data.resultSet);
      setisloading(false);
    });
    // }
  };

  let billingPartyNames = [];
  if (billingParty.length > 0) {
    const filterdBillers = billingParty.filter(obj => { return obj.billingPartyName.toLowerCase().startsWith(Txt) })
    console.log("filterdBillers", filterdBillers);
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.billingPartyId;
      temp.text = `${object.billingPartyName} (${object.billingPartyCode})`
      temp.value = object.billingPartyId;
      return (billingPartyNames[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
    const customerNo = localStorage.getItem('customerNumber')
    if (data.value) {
      if (customerTypeName != null && customerTypeName != undefined) {
        getBillingPartySelected(data.value, customerTypeName, customerTypeId, setFieldValue)
      }
      else {
        getBillingPartySelected && getBillingPartySelected(data.value)
      }
      setFieldValue(billingPartyBranchName, "")
      setFieldValue(billingPartyBranchId, "")
      props.onChangeExtra && props.onChangeExtra(data.value)
    } else {
      setFieldValue(name, "")
      setFieldValue(billingPartyBranchName, "")
    }

    function isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    }

    console.log("Data Value ====> ", data.value)
    if (data.value && customerNo == 1183) {
      setFieldValue(consignorName, "")
      setFieldValue(consignorCode, "")
      setFieldValue(consignorGst, "")
      setFieldValue(consignorAddress, "")

      setFieldValue(consigneeName, "")
      setFieldValue(consigneeCode, "")
      setFieldValue(consigneeGst, "")
      setFieldValue(consigneeAddress, "")
      setFieldValue(deliverToAddress, "")
    } else if (isEmpty(data.value) && customerNo == 1183) {
      setFieldValue(consignorName, "")
      setFieldValue(consignorCode, "")
      setFieldValue(consignorGst, "")
      setFieldValue(consignorAddress, "")

      setFieldValue(consigneeName, "")
      setFieldValue(consigneeCode, "")
      setFieldValue(consigneeGst, "")
      setFieldValue(consigneeAddress, "")
      setFieldValue(deliverToAddress, "")
    }
  };

  let OptionsList = billingPartyNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);

  return (
    <>
      <Dropdown
        selection
        search
        clearable
        name={name}
        loading={isloading}
        // style={{ width: "100%" }}
        onChange={handleChange}
        options={OptionsList}
        onSearchChange={localStorage.getItem('customerNumber') != 1183 ? handleSearch : false}
        placeholder={props.placeholder}
        {...props}
      />
    </>
  );
};

export default MyBillingPartyComponent;
